<template>
  <div>
    <b-card>

      <div class="d-flex justify-content-between mb-3">
        <h3>AI Call Logs</h3>
      </div>

      <b-table :items="callLogs" :fields="fields" small responsive>

        <template #cell(customer_name)="row">
          {{ row.item.customer_data && row.item.customer_data.name ? row.item.customer_data.name : row.item.customer_name || '-' }}
        </template>

        <template #cell(customer_phone)="row">
          {{ row.item.customer_data && row.item.customer_data.phone ? row.item.customer_data.phone : row.item.customer_phone || '-' }}
        </template>

        <template #cell(call_status)="row">
          <b-badge :variant="statusVariant(row.item.call_status)">
            {{ row.item.call_status }}
          </b-badge>
        </template>

        <template #cell(duration)="row">
          {{ row.item.duration !== null && row.item.duration !== undefined ? row.item.duration + ' sec' : '-' }}
        </template>

        <template #cell(manage)="row">
          <b-button size="sm" variant="secondary"
                    @click="viewTranscript(row.item)">
            Transcript
          </b-button>
        </template>

      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalItems"
        :per-page="perPage"
        align="right"
        class="mt-3"
      />

    </b-card>

    <CreateAICallLogModal
      @modalClosed="fetchCallLogs"
      :key="createKey"
    />

    <EditAICallLogModal
      :callLog="selectedCall"
      @modalClosed="fetchCallLogs"
      :key="editKey"
    />

    <ViewTranscriptModal
      :callLog="selectedCall"
      :key="transcriptKey"
    />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import CreateAICallLogModal from "@/components/ai_call_log/CreateAICallLogModal.vue";
// import EditAICallLogModal from "@/components/ai_call_log/EditAICallLogModal.vue";
import ViewTranscriptModal from "@/components/ai_call_log/ViewTranscriptModal.vue";

export default {
  components: {
    CreateAICallLogModal,
    // EditAICallLogModal,
    ViewTranscriptModal
  },

  data() {
    return {
      fields: [
        { key: "customer_name", label: "Customer Name" },
        { key: "customer_phone", label: "Customer Phone" },
        { key: "call_status", label: "Status" },
        { key: "duration", label: "Duration" },
        { key: "created_at", label: "Date" },
        { key: "manage", label: "Manage" },
      ],
      callLogs: [],
      selectedCall: null,
      currentPage: 1,
      totalItems: 0,
      perPage: 0,
      createKey: 0,
      editKey: 0,
      transcriptKey: 0,
    };
  },

  mounted() {
    this.fetchCallLogs();
  },

  methods: {
    ...mapActions("appData", ["getAICallLogs"]),

    async fetchCallLogs() {
      const res = await this.getAICallLogs({
        page: this.currentPage,
      });

      this.callLogs = res.data.results;
      this.totalItems = res.data.count;
      this.perPage = res.data.per_page;
    },

    openCreate() {
      this.createKey++;
      this.$nextTick(() =>
        this.$bvModal.show("create-ai-call-log-modal")
      );
    },

    // editCall(call) {
    //   this.selectedCall = call;
    //   this.editKey++;
    //   this.$nextTick(() =>
    //     this.$bvModal.show("edit-ai-call-log-modal")
    //   );
    // },

    viewTranscript(call) {
      this.selectedCall = call;
      this.transcriptKey++;
      this.$nextTick(() =>
        this.$bvModal.show("view-transcript-modal")
      );
    },

    statusVariant(status) {
      if (status === "completed") return "success";
      if (status === "no_answer") return "warning";
      if (status === "failed") return "danger";
      return "secondary";
    },
  },

  watch: {
    currentPage() {
      this.fetchCallLogs();
    },
  },
};
</script>